import { v4 as uuidv4 } from "uuid";

import { RESEARCH_TEAM } from "globals/constants/formObjects";

export const initialAssociation = {
	association: null,
	credit: null,
	costShareEffort: {
		calendar: null,
		academic: null,
		summer: null,
	},
	sponsoredEffort: {
		calendar: null,
		academic: null,
		summer: null,
	},
	costShareEffortMonths: {
		calendar: null,
		academic: null,
		summer: null,
	},
	sponsoredEffortMonths: {
		calendar: null,
		academic: null,
		summer: null,
	},
	totalEffort: 0,
	totalEffortMonths: 0,
};

export const initialMember = {
	associationType: RESEARCH_TEAM.ASSOCIATION_TYPE.INTERNAL,
	member: null,
	role: null,
	associations: [ initialAssociation ],
	externalAssociations: [],
	isInitialCalculationRequired: false,
	key: uuidv4()
};
